import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
// import { Container } from 'reactstrap';
import requestOrganizationById from './graphql';
import history from '../../config/history';
import { tomcatHost, cloudFrontCdnUrl } from '../../config/properties';
import { downloadFile } from '../../utils/fileDownload';
import {
  inventoryManagementRoute,
} from '../../config/navigation/routes';

export default function InventoryManagementHOC(InventoryManagementPage) {
  class WrappedComponent extends Component {
    static propTypes = {
      auth: PropTypes.shape({
        jwtToken: PropTypes.string.isRequired,
        expiration: PropTypes.number.isRequired,
        organizationId: PropTypes.string.isRequired,
        role: PropTypes.string.isRequired,
        id: PropTypes.string.isRequired,
        email: PropTypes.string.isRequired,
        cageCode: PropTypes.string.isRequired,
      }).isRequired,
      location: PropTypes.shape({
        pathname: PropTypes.string.isRequired,
      }).isRequired,
    };

    static initialState = {
      users: [],
      errors: [],
      isLoading: true,
      isDownloading: false,
      selectedMenu: {
        text: 'Inventory Items',
        value: 'inventoryGrid',
      },
      orgName: '',
      loading: false,
      demoInitialValues: {},
      suppInitialValues: {},
      organizationsStatus: undefined,
      inventoryFilter: undefined,
      orgCage: undefined,
    };

    state = WrappedComponent.initialState;

    async componentDidMount() {
      const {
        location: { pathname },
      } = this.props;
      const page = pathname.match(/([^/]*)\/*$/)[1];

      if (page === ':page' || page === 'home') {
        const url = inventoryManagementRoute.replace(':page', 'inventoryGrid');
        history.replace(url);
      } else {

        const filter = {
          addInventory: { text: 'Add Inventory', value: 'addInventory' },
          downloadInventory: { text: 'Download Inventory', value: 'downloadInventory' },
          uploadInventory: { text: 'Upload Inventory', value: 'uploadInventory' },
          inventoryGrid: { text: 'Inventory Items', value: 'inventoryGrid' },
        };

        this.setState({ selectedMenu: filter[page] });

      }
      const { organizationId, id } = this.props.auth;
      const response = await requestOrganizationById(organizationId, id);
      const orgName =
        (response.organization && response.organization.name) || undefined;

      this.setState({
        userOrgId: response.user.organizationId,
        orgName,
        isLoading: false,
      });
    }

    // async componentWillReceiveProps(nextProps) {
    //   // if (this.props.auth.organizationId !== nextProps.auth.organizationId) {
    //   //   this.setState({
    //   //     isLoading: true,
    //   //   });
    //   //   const response = await requestOrganizationById(
    //   //     nextProps.auth.organizationId,
    //   //     nextProps.auth.id,
    //   //   );

    //   //   const orgName =
    //   //     (response.organization && response.organization.name) || 'No-Name';
    //   //   this.setState({
    //   //     isLoading: false,
    //   //     orgName,
    //   //   });
    //   // }
    //   const pathname = nextProps.location.pathname;
    //   const page = pathname.match(/([^\/]*)\/*$/)[1];
    //   if (page === ':page' || page === 'home') {
    //     const url = inventoryManagementRoute.replace(':page', 'inventoryGrid');
    //     history.replace(url);
    //   }
    // }

    _onReturnToMainPage = () => {
      this.setState({
        selectedMenu: {
          text: 'Inventory Items',
          value: 'inventoryGrid',
        }
      });
      const url = inventoryManagementRoute.replace(':page', "inventoryGrid");
      history.replace(url);
    }

    _onFilterClick = filter => {
      if (filter.value !== 'downloadInventory') {
        this.setState({ selectedMenu: filter });
      }
      let url;
      switch (filter.value) {
        case 'downloadInventory':
          history.push(this._downloadManagementData());
          break;
        default:
          url = inventoryManagementRoute.replace(':page', filter.value);
          history.replace(url);
          break;
      }
    };

    _onInventoryFilter = () => {
      if (document.getElementById('niin').value !== '') {
        this.setState({
          inventoryFilter: {
            field: 'niin',
            value: document.getElementById('niin').value
          },
        });
      } else if (document.getElementById('partNum').value !== '') {
        this.setState({
          inventoryFilter: {
            field: 'partNum',
            value: document.getElementById('partNum').value
          },
        });
      } else if (document.getElementById('description').value !== '') {
        this.setState({
          inventoryFilter: {
            field: 'description',
            value: document.getElementById('description').value
          },
        });
      } else {
        this.setState({ inventoryFilter: undefined });
      }
    };

    setDownloading = (downloading) => {
      this.setState({ isDownloading: downloading });
    }

    _downloadManagementData = async () => {
      // const { organizationId, id } = this.props.auth;
      // const response = await requestOrganizationById(organizationId, id);
      this.setDownloading(true);
      const cageCode = this.props.auth.cageCode;
      const url = `${cloudFrontCdnUrl}/${tomcatHost}/tools/download/inventory-management/cage/${cageCode}`;
      const fileName = `InventoryManagementData for cage ${cageCode}`
      await downloadFile(url, "csv", fileName, this.props.auth.jwtToken, this.setDownloading);
    };

    render() {
      const {
        isLoading,
        isDownloading,
        selectedMenu,
        loading,
        orgName,
        userOrgId,
        inventoryFilter,
      } = this.state;
      const { auth } = this.props;
      const pageProps = {
        userOrgId,
        orgName,
        auth,
        loading,
        isLoading,
        isDownloading,
        selectedMenu,
        onMenuClick: this._onFilterClick,
        onInventoryFilter: this._onInventoryFilter,
        inventoryFilter,
        onReturnToMainPage: this._onReturnToMainPage,
      };

      return (
        <InventoryManagementPage
          openInventoryModal={this.openInventoryModal}
          closeModal={this.closeModal}
          handleOkInventoryLookup={this.handleOkInventoryLookup}
          {...pageProps}
        />
      );
    }
  }

  return withRouter(WrappedComponent);
}



// WEBPACK FOOTER //
// ./src/pages/InventoryManagement/InventoryManagementHOC.jsx